import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'motion/react'
import type { FieldValues } from '../../fieldTypes'

const pages = [
  { key: 'a', label: 'Dashboard', color: 'from-sky-500 to-blue-600' },
  { key: 'b', label: 'Settings', color: 'from-amber-500 to-orange-600' },
]

export function CrossfadeScale({ values = {} }: { values?: FieldValues }) {
  const [index, setIndex] = useState(0)
  const initialScale = values.initialScale ?? 0.9
  const exitScale = values.exitScale ?? 1.05
  const duration = values.duration ?? 0.4
  const ease = values.ease ?? 'easeInOut'

  useEffect(() => {
    const interval = setInterval(() => setIndex((i) => (i + 1) % pages.length), 2500)
    return () => clearInterval(interval)
  }, [])

  const page = pages[index]

  return (
    <div className="flex items-center justify-center h-full overflow-hidden">
      <AnimatePresence mode="wait">
        <motion.div
          key={page.key}
          initial={{ opacity: 0, scale: initialScale }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: exitScale }}
          transition={{ duration, ease }}
          className={`w-32 h-20 bg-gradient-to-br ${page.color} rounded-xl shadow-lg flex items-center justify-center`}
        >
          <span className="text-white text-xs font-semibold">{page.label}</span>
        </motion.div>
      </AnimatePresence>
    </div>
  )
}
